import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.custom.pageBackground,
    // Makes native scrollbars / form controls follow the active theme.
    colorScheme: theme.palette.type,
    '& .MuiPaper-root': {
      elevation: 3,
    },
    overflow: 'visible',
    minHeight: 'calc(100vh - 100px)',
  },
  productTable: {
    '& .MuiTableCell-root': {
      color: theme.palette.primary.gray,
    },
    '& .MuiTableCell-head': {
      color: theme.palette.primary.gray,
    },
    '& .MuiTableCell-paddingNone': {
      color: theme.palette.primary.mainBlue,
      fontWeight: 'bold',
    },
    '& .Mui-checked': {
      color: theme.palette.secondary.blue,
    },
    '& .MuiTableRow-root': {
      '&:hover': {
        backgroundColor: theme.palette.custom.tableRowHover,
      },
    },
    '& .Mui-selected': {
      backgroundColor: theme.palette.custom.tableRowHover,
    },
    minWidth: '150%',
  },
  iconsCell: {
    '& svg': {
      color: theme.palette.primary.gray,
      cursor: 'pointer',
    },
  },
  roleCells: {
    fontSize: '11px',
  },
  title: {
    flexGrow: 1,
    marginBottom: '20px',
  },
  toolbarTable: {
    '& .MuiOutlinedInput-root': {
      height: '35px',
      fontSize: '13px',
      width: '350px',
    },
    '& .Mui-focused': {
      border: `1px solid ${theme.palette.secondary.gray}`,
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.secondary.lightGray,
    },
    '& .MuiOutlinedInput-adornedStart': {
      paddingLeft: '2px',
    },
    '& button': {
      backgroundColor: theme.palette.custom.inputBackground,
      color: theme.palette.secondary.gray,
      fontSize: '13.5px',
      '& svg': {
        color: theme.palette.secondary.gray,
      },
    },
    '& .MuiMenuItem-root': {
      color: theme.palette.custom.menuItemText,
    },
  },
  popper: {
    zIndex: 2,
    width: '110px',
    '& ul': {
      paddingBottom: '0px',
    },
  },
  titleOption: {
    borderBottom: `1px solid ${theme.palette.secondary.gray}`,
  },
  roleOption: {
    fontSize: '12px',
  },
  activeOption: {
    fontSize: '13.5px',
  },
  clearOption: {
    fontSize: '13.5px',
    borderTop: `1px solid ${theme.palette.secondary.gray}`,
  },
  noContent: {
    height: '710px',
  },
  progress: {
    height: '610px',
    display: 'table-cell',
    textAlign: 'center',
    padding: '50px',
    '& div': {
      color: theme.palette.primary.main,
    },
    '& h4': {
      color: theme.palette.primary.main,
      fontWeight: '200',
    },
  },
  productInfo: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '20px',
    padding: '20px',
    maxWidth: '1200px',
    margin: '0 auto',
    '@media (max-width: 768px)': {
      gridTemplateColumns: '1fr',
      padding: '15px',
      gap: '15px',
    },
    '& .MuiInputLabel-formControl': {
      transform: 'translate(14px, -9px) scale(0.75)',
      transformOrigin: 'top left',
      position: 'absolute',
      zIndex: 1,
      pointerEvents: 'none',
      backgroundColor: theme.palette.background.paper,
      padding: '0 4px',
    },
    '& .MuiFormLabel-root': {
      color: theme.palette.secondary.darkGray,
      fontSize: '14px',
    },
    '& .MuiFormControl-root': {
      marginTop: '25px',
    },
    '& input': {
      padding: '10px',
    },
    '& .MuiSelect-root': {
      padding: '10px',
      fontSize: '13.5px',
    },
    '& .MuiInputBase-input': {
      fontSize: '14px',
    },
  },
  imageSection: {
    gridColumn: '1 / -1',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px',
    '@media (max-width: 768px)': {
      marginBottom: '15px',
    },
  },
  productImage: {
    maxWidth: '300px',
    maxHeight: '300px',
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    borderRadius: '4px',
    border: `1px solid ${theme.palette.custom.imageBorder}`,
    '@media (max-width: 768px)': {
      maxWidth: '250px',
      maxHeight: '250px',
    },
  },
  formField: {
    position: 'relative',
  },
  itemList: {
    fontSize: '13.5px',
    color: theme.palette.custom.menuItemText,
  },
  role: {
    gridColumn: 1,
  },
  selectOulined: {
    marginTop: '26px',
  },
  buttonsContainer: {
    gridColumn: '1 / -1',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '25px',
    '@media (max-width: 768px)': {
      marginTop: '20px',
    },
    '& button': {
      minWidth: '200px',
      padding: '12px 24px',
      color: theme.palette.custom.solidButtonText,
      backgroundColor: theme.palette.custom.solidButtonBackground,
      borderRadius: '10px',
      '@media (max-width: 768px)': {
        minWidth: '150px',
        padding: '10px 20px',
      },
    },
  },
  buttonColumn: {
    gridRow: 7,
  },
  products: {
    display: 'table-cell',
    textAlign: 'center',
    padding: '50px',
    '& svg': {
      width: '40px',
      height: '40px',
      color: theme.palette.primary.main,
    },
    '& h4': {
      color: theme.palette.primary.main,
      fontWeight: '200',
    },
  },
  header: {
    display: 'flex',
  },
  tableHeader: {
    color: theme.palette.secondary.gray,
    '& .Mui-checked': {
      color: theme.palette.secondary.blue,
      opacity: 0.5,
    },
    '& .MuiCheckbox-indeterminate ': {
      color: theme.palette.secondary.blue,
      opacity: 0.5,
    },
  },
  editDeleteButtons: {
    marginRight: '20px',
    '& .MuiIconButton-root': {
      width: '35px',
      '&:hover': {
        backgroundColor: theme.palette.custom.cardBackground,
      },
    },
  },
  info: {
    boxShadow: '0px 5px 12px 0px rgba(0,0,0,0.02)',
  },
}));

export default useStyles;
